import PremiumSimulatorApi from "./premiumSimulatorApi";
import * as types from "./premiumSimulatorTypes";

export function simulate(clientId, body, headers, options, query) {
  return {
    type: types.SIMULATE,
    promise: PremiumSimulatorApi.submit(
      clientId,
      body,
      headers,
      options,
      query
    ),
    payload: { clientId, parameters: { ...body } },
  };
}

export function clear(clientId) {
  return {
    type: types.CLEAR_SIMULATOR,
    payload: { clientId },
  };
}



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/premiumSimulatorActions.js